import { Skeleton } from '@chakra-ui/react';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { z } from 'zod';

import { useGetAssignmentStrategyQuery } from '../../../../../types/dashboard-core-gqlTypes.generated.d';
import { AssignmentStrategyForm } from './assignmentStrategyForm/AssignmentStrategyForm';

// Types
const RouteParamsStruct = z.object({
  strategyId: z.string({ message: 'Missing URL parameter' }),
  implementationId: z.string().optional(), // implementationId is in URL when in assignment workflow, but not in url on settings strategy page
});

// Exports
export const AssignmentEditStrategyContainer = ({
  readOnly,
}: {
  readOnly: boolean;
}) => {
  const navigate = useNavigate();
  const params = useParams();

  const { strategyId, implementationId } = RouteParamsStruct.parse(params);

  const {
    data,
    loading: assignmentStrategyLoading,
    refetch: refetchAssignmentStrategy,
  } = useGetAssignmentStrategyQuery({
    variables: { strategyId, implementationId },
    fetchPolicy: 'network-only',
    onError: () => {
      navigate(
        readOnly
          ? `/assignments/${implementationId}/strategy`
          : '/settings/assignment-strategy',
      );
    },
  });

  if (!data || assignmentStrategyLoading) {
    return <Skeleton height="80vh" />;
  }

  return (
    <AssignmentStrategyForm
      implementationId={data.assignmentStrategy.implementationId}
      strategyId={strategyId}
      initialStrategyName={data.assignmentStrategy.name}
      initialDescription={data.assignmentStrategy.description ?? ''}
      initialLoanProductCriteria={data.assignmentStrategy.loanProductCriteria}
      initialEligibilityExclusions={
        data.assignmentStrategy.eligibilityExclusions
      }
      initialDecisionHeuristic={JSON.parse(
        data.assignmentStrategy.decisionHeuristic,
      )}
      refetchAssignmentStrategy={refetchAssignmentStrategy}
      backUrl={
        readOnly
          ? `/assignments/${data.assignmentStrategy.implementationId}/strategy`
          : '/settings/assignment-strategy'
      }
      readOnly={readOnly}
    />
  );
};
